import React from "react";
import { ActivityCalendar } from "../../../../../components";

export const ActivityCalendarList = () => {
  return (
    <div>
      <ActivityCalendar />
    </div>
  );
};
